import { render } from "./ProfilingChart.vue?vue&type=template&id=0625d9ba&ts=true"
import script from "./ProfilingChart.vue?vue&type=script&lang=ts"
export * from "./ProfilingChart.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__